<div class="dropdown topbar-head-dropdown ms-1 header-item" ngbDropdown>
    <button type="button" class="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
        id="page-header-notifications-dropdown" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
        ngbDropdownToggle>
        <!-- <i class='ri-notification-4-line fs-22'></i> -->
        <i class='ri-notification-4-fill fs-22 text-primary'></i>
        <span class="position-absolute topbar-badge fs-10 translate-middle rounded-pill bg-danger"><span
                class="visually-hidden">unread messages</span></span>
    </button>
    <div class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
        aria-labelledby="page-header-notifications-dropdown" ngbDropdownMenu>
        <div class="dropdown-head bg-primary bg-pattern rounded-top">
            <div class="p-3">
                <div class="row align-items-center">
                    <div class="col">
                        <h6 class="m-0 fs-16 fw-semibold text-white"> Notifications </h6>
                    </div>
                    <div class="col-auto dropdown-tabs">
                        <span class="badge badge-soft-light fs-13"> 4 New</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="tab-content" id="notificationItemsTabContent">
            <div class="tab-content text-muted">
                <div class="px-2 pt-2">
                    <div class="tab-pane fade show active py-2 ps-2" id="all-noti-tab" role="tabpanel">
                        <ngx-simplebar style="max-height: 300px;">
                            <div class="pe-2">
                                <div class="text-reset notification-item d-block dropdown-item position-relative">
                                    <div class="d-flex">
                                        <div class="avatar-xs me-3">
                                            <span class="avatar-title bg-soft-info text-info rounded-circle fs-16">
                                                <i class="bx bx-badge-check"></i>
                                            </span>
                                        </div>
                                        <div class="flex-1">
                                            <a href="javascript:void(0);" class="stretched-link">
                                                <h6 class="mt-0 mb-2 lh-base">Your <b>Elite</b>
                                                    author Graphic
                                                    Optimization <span class="text-secondary">reward</span> is
                                                    ready!
                                                </h6>
                                            </a>
                                            <p class="mb-0 fs-11 fw-medium text-uppercase text-muted">
                                                <span><i class="mdi mdi-clock-outline"></i> Just
                                                    30 sec ago</span>
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="text-reset notification-item d-block dropdown-item position-relative">
                                    <div class="d-flex">
                                        <img src="assets/images/users/avatar-2.jpg"
                                            class="me-3 rounded-circle avatar-xs" alt="user-pic">
                                        <div class="flex-1">
                                            <a href="javascript:void(0);" class="stretched-link">
                                                <h6 class="mt-0 mb-1 fs-13 fw-semibold">Angela
                                                    Bernier</h6>
                                            </a>
                                            <div class="fs-13 text-muted">
                                                <p class="mb-1">Answered to your comment on the
                                                    cash flow forecast's
                                                    graph 🔔.</p>
                                            </div>
                                            <p class="mb-0 fs-11 fw-medium text-uppercase text-muted">
                                                <span><i class="mdi mdi-clock-outline"></i> 48
                                                    min ago</span>
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="text-reset notification-item d-block dropdown-item position-relative">
                                    <div class="d-flex">
                                        <div class="avatar-xs me-3">
                                            <span class="avatar-title bg-soft-danger text-danger rounded-circle fs-16">
                                                <i class='bx bx-message-square-dots'></i>
                                            </span>
                                        </div>
                                        <div class="flex-1">
                                            <a href="javascript:void(0);" class="stretched-link">
                                                <h6 class="mt-0 mb-2 fs-13 lh-base">You have
                                                    received <b class="text-success">20</b> new
                                                    messages in the conversation</h6>
                                            </a>
                                            <p class="mb-0 fs-11 fw-medium text-uppercase text-muted">
                                                <span><i class="mdi mdi-clock-outline"></i> 2
                                                    hrs ago</span>
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="text-reset notification-item d-block dropdown-item position-relative">
                                    <div class="d-flex">
                                        <img src="assets/images/users/avatar-8.jpg"
                                            class="me-3 rounded-circle avatar-xs" alt="user-pic">
                                        <div class="flex-1">
                                            <a href="javascript:void(0);" class="stretched-link">
                                                <h6 class="mt-0 mb-1 fs-13 fw-semibold">Maureen
                                                    Gibson</h6>
                                            </a>
                                            <div class="fs-13 text-muted">
                                                <p class="mb-1">We talked about a project on
                                                    linkedin.</p>
                                            </div>
                                            <p class="mb-0 fs-11 fw-medium text-uppercase text-muted">
                                                <span><i class="mdi mdi-clock-outline"></i> 4
                                                    hrs ago</span>
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="my-3 text-center">
                                    <a type="button" [routerLink]="'/' + uiState.routers.base"
                                        class="btn btn-soft-success waves-effect waves-light">View
                                        All Notifications <i class="ri-arrow-right-line align-middle"></i></a>
                                </div>
                            </div>
                        </ngx-simplebar>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>